export function onSignatureTypeSelect(value) {
  return {
    type: 'ON_SIGNATURE_TYPE_SELECT',
    value
  };
}


// WEBPACK FOOTER //
// ./src/actions/SignatureTypeAction.js